import { ReactionSearchPreferenceSchema } from '@retro-ui/prisma';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/parameter-preset';

const EditableReactionSearchPreferenceSchema = ReactionSearchPreferenceSchema.pick({
  name: true,
  isApiDefault: true,
  searchParams: true,
});

export const parameterPresetContract = c.router(
  {
    fetchPresets: {
      method: 'GET',
      path: '',
      responses: {
        200: z.array(ReactionSearchPreferenceSchema),
      },
    },
    createPreset: {
      method: 'POST',
      path: '',
      body: EditableReactionSearchPreferenceSchema,
      responses: {
        201: ReactionSearchPreferenceSchema,
      },
    },
    updatePreset: {
      method: 'PATCH',
      path: '/:id',
      pathParams: z.object({
        id: z.string(),
      }),
      body: EditableReactionSearchPreferenceSchema.extend({
        name: EditableReactionSearchPreferenceSchema.shape.name.optional(),
        searchParams: EditableReactionSearchPreferenceSchema.shape.searchParams.optional(),
      }),
      responses: {
        200: ReactionSearchPreferenceSchema,
      },
    },
    removePreset: {
      method: 'DELETE',
      path: '',
      body: z.array(ReactionSearchPreferenceSchema.shape.id),
      responses: {
        200: z.array(ReactionSearchPreferenceSchema.shape.id),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
